import loadable from '@loadable/component';
import { Toaster as ToasterHotToast } from 'react-hot-toast';
import { shallowEqual, useSelector } from 'react-redux';
import { ProductFruits } from 'react-product-fruits';
import { Router, Switch } from 'react-router-dom';
import { history } from './lib/routeHistory';
import { NavBarContextProvider } from './components/Header/NavBar/NavBarContext';
import MainRefactored from './modules/main/scenes/MainRefactored';
import type { RootState } from './rootReducer';
import { PaywallEmailModal } from './components/organisms/PaywallEmailModal/PaywallEmailModal';
import { AppGlobalProvider } from './providers/AppGlobalProviders';
import { initMonitoringLog } from './lib/monitoringLog';
import { Toaster } from './components/atoms/Toast';
import { hotjar } from 'react-hotjar';

const Main = loadable(() => import('./modules/main/scenes/Main'));

export const Routes = (): JSX.Element => {
	const [user] = useSelector(
		(state: RootState) => [state.user.getIn(['authorize', 'user']).toJS()],
		shallowEqual
	);
	hotjar.initialize(2916226, 6);
	if (hotjar.initialized() && user?._id) {
		hotjar.identify(user._id, {
			name: user.name,
			email: user.email,
			role: user.role
		});
	}
	initMonitoringLog();

	return (
		<Router history={history}>
			<Switch>
				<AppGlobalProvider>
					{user && user.name && (
						<ProductFruits
							workspaceCode="bHU0rkthiLgiic1L"
							language="en"
							user={{
								username: user.email,
								email: user.email,
								firstname: user.name,
								role: user.role,
								props: { company: user.company?.name }
							}}
						/>
					)}

					<PaywallEmailModal />

					<ToasterHotToast
						position="bottom-right"
						toastOptions={{
							duration: 3000,
							style: {
								color: '#74F59E',
								backgroundColor: '#121212',
								maxWidth: '500px',
								padding: '10px 20px'
							},
							iconTheme: {
								primary: '#74F59E',
								secondary: '#121212'
							},
							error: {
								style: {
									color: '#D32F2F',
									backgroundColor: '#121212',
									maxWidth: '500px',
									padding: '10px 20px'
								},
								iconTheme: {
									primary: '#D32F2F',
									secondary: '#121212'
								}
							}
						}}
					/>

					<Toaster />

					<NavBarContextProvider>
						{user?.features?.platformRedesign ? (
							<MainRefactored />
						) : (
							<Main />
						)}
					</NavBarContextProvider>
				</AppGlobalProvider>
			</Switch>
		</Router>
	);
};
